import * as Yup from "yup";

export function initialValues(item) {
  return {
    title: item?.title || "",
    description: item?.description || "",
    projectAction: item?.projectAction || null,
    environmentalFactor: item?.environmentalFactor || null,
    magnitude: item?.magnitude ?? null,
    importance: item?.importance || null,
    controls: item?.controls || "",
    action: item?.action || "",
  };
}

export function validationSchema(t) {
  return Yup.object({
    title: Yup.string().required(t("required_field")),
    projectAction: Yup.string().required(t("required_field")),
    environmentalFactor: Yup.string().required(t("required_field")),
    magnitude: Yup.number()
      .min(-10)
      .max(10)
      .required(t("required_field"))
      .test("not-zero", t("required_field"), (value) => value !== 0),
    importance: Yup.number().min(1).max(10).required(t("required_field")),
  });
}
